import React, { Component } from "react";

import Box from "../ui/Box";
import { FlatButton } from "material-ui";
import { TYPES, additionalFeaturesConfig } from "./AdditionalSettings";

//services
import DataService from "../../services/DataService";
var ds = DataService;

export default class AdditionalSettingsPage extends Component {
  constructor(props) {
    super(props);
    // this.displayFeatureArray = [];
    this.additionalFeaturesConfig = additionalFeaturesConfig;
    this.state = {
      displayFeatureArray: this.props.settings,
      userDeviceID: this.props.userDeviceID,
      kiotDeviceID: this.props.kiotDeviceID,
      hotelID: this.props.hotelID,
    };
  }
  componentDidMount() {
    window.addEventListener("_mqt", (e) => {
      if (
        e &&
        e.ev &&
        e.ev.name == "CFG_RCVD" &&
        e.ev.val == "1" &&
        e.device_id == this.state.kiotDeviceID
      ) {
        // this.loaderFlag = false;
        // const successToast = await this.toast.create({
        //   message: this.translateService.instant(`${this.TRANSLATE_MODULE}.saved`),
        //   duration: 2000
        // });
        // await successToast.present();
      }
    });
  }

  featureToogled(feature, index) {
    let featureAction;
    if (feature.inputType == TYPES.bool) {
      if (feature.data.isEnabled === true) {
        featureAction = "enable";
      } else {
        featureAction = "disable";
      }
    } else {
      featureAction = feature.data.value;
    }
    // console.log(ev);
    this.saveAdditionalSettingsInServer({
      featureName: feature.actualName,
      featureAction,
    })
      .then(() => {
        //this.loaderFlag = true;

        setTimeout(async () => {
          if (this.loaderFlag) {
            // checks whether we recieved any response from mqtt or not
            if (feature.inputType == TYPES.bool) {
              feature.data.isEnabled = !feature.data.isEnabled;
            }
            // else if (feature.inputType == TYPES.select) {
            //   feature.data.value = "";
            // }
            const failureToast = await this.toast.create({
              message: this.translateService.instant(
                `${this.TRANSLATE_MODULE}.notSaved`
              ),
              duration: 2000,
            });
            await failureToast.present();
          }
          this.loaderFlag = false;
        }, this.TIMEOUT);
      })
      .catch((e) => {
        feature.data.isEnabled = !feature.data.isEnabled;
        this.loaderFlag = false;
      });
  }

  saveAdditionalSettingsInServer({ featureName, featureAction }) {
    return new Promise((resolve, reject) => {
      ds.saveUserDeviceAdditionalSettings(
        featureName,
        featureAction,
        this.state.hotelID,
        this.state.userDeviceID,
        (data) => resolve(),
        (err) => reject()
      );
    });
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount() {
    //clearInterval(this.state.timeout_forPing2);
    //_mqtt.disconnect();
    window.removeEventListener("_mqt", (data) => {
      console.log(data);
    });
  }

  render() {
    return (
      <Box header="Additional Settings">
        {this.state.displayFeatureArray.length ? (
          <section>
            <div>
              <span>
                Given below is the list of additional features supported by this
                device.
              </span>
            </div>
            {this.state.displayFeatureArray.map((feature, index) => {
              return (
                <div style={{ marginTop: "15px" }}>
                  <div
                    style={{
                      display: "inline-block",
                      height: "40px",
                      marginRight: "25px",
                    }}
                  >
                    <span style={{ position: "relative", top: "6px" }}>
                      {feature.displayName}
                    </span>
                  </div>
                  {feature.inputType == TYPES.bool && (
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={
                          this.state.displayFeatureArray[index].data.isEnabled
                        }
                        onClick={(e) => {
                          let updatedFeatures = this.state.displayFeatureArray;
                          if (e.target.checked) {
                            // updatedFeatures[index].data.isEnabled = !updatedFeatures[index].data.isEnabled;
                            // // } else {
                            updatedFeatures[index].data.isEnabled = true;
                          } else {
                            updatedFeatures[index].data.isEnabled = false;
                          }
                          // // }
                          this.setState(
                            { displayFeatureArray: [...updatedFeatures] },
                            () => {
                              this.featureToogled(feature, index);
                            }
                          );
                        }}
                      />
                      <span className="slider round"></span>
                    </label>
                  )}
                </div>
              );
            })}
            {/* <TextField
            floatingLabelText="Switch Name"
            name="cust_name"
            className="w-100"
            value={this.state.switch_appliance.name}
            onChange={(e) => {
              let x = this.state.switch_appliance;
              x.name = e.target.value;
              this.setState({
                switch_appliance: x
              })
            }}
          /> */}
          </section>
        ) : (
          <section>
            <h5>No Additional Settings available for this device!!!</h5>
          </section>
        )}

        <div className="mt-4vw align-right">
          {/* <RaisedButton
            label="Save"
            primary
            onClick={this.saveSwitch.bind(this)}
            type="button"
          /> */}
          <FlatButton
            label="Cancel"
            primary
            onClick={this.props.unMountMe.bind(this, false)}
            type="button"
          />
        </div>
      </Box>
    );
  }
}



// WEBPACK FOOTER //
// ./components/rooms/AdditionalSettingsPage.js